import { AUDIT_ROUTE, USERS_ROUTE } from '../../domain/routes.js';

export type NavVisibility = { auditConfigured: boolean; usersConfigured: boolean };

/** Hides Audit log while `audit.status()` says the feature is off, and Users while `users.status()` does — every other link always shows. */
export const visibleNavLinks = <L extends { to: string }>(links: readonly L[], visibility: NavVisibility): L[] =>
    links.filter(
        (link) =>
            (link.to !== AUDIT_ROUTE || visibility.auditConfigured) &&
            (link.to !== USERS_ROUTE || visibility.usersConfigured),
    );

/** Each section once, under its eyebrow, in the order its first link appears — after any hide rule has run. */
export const navSections = <L extends { section: string }>(
    links: readonly L[],
): { section: L['section']; links: L[] }[] => {
    const out: { section: L['section']; links: L[] }[] = [];
    for (const link of links) {
        const group = out.find((g) => g.section === link.section);
        if (group) group.links.push(link);
        else out.push({ section: link.section, links: [link] });
    }
    return out;
};

/** An item is active when the path is it or under it: `/studios/*` lights Studios, `/games/*` lights Games. */
export const isActiveNav = (to: string, pathname: string): boolean => pathname === to || pathname.startsWith(`${to}/`);
